module.exports = __webpack_public_path__ + "img/star.afcb1185.svg";